// extracted by mini-css-extract-plugin
module.exports = {"button3":"ReadProduct_button3__39Bev","selectCategory":"ReadProduct_selectCategory__3QyGT","label":"ReadProduct_label__3FkHj","General":"ReadProduct_General__35n1P"};